require(`./scss/${process.env.ENTRY_POINT}/product-pool-media.scss`);
const CarouselView = require('./views/CarouselView');
const GridView = require('./views/Grid');
const ProductPoolGrid = require('./views/ProductPoolGrid');
const ProductPoolMedia = require('./views/ProductPoolMedia');
const {
  HORIZONTAL,
  VERTICAL,
  ITEM_SCROLL_TYPE,
  PAGE_SCROLL_TYPE,
  NEXT_EVENT,
  PREV_EVENT,
  READY_EVENT,
  LAST_PAGE_EVENT,
  PAGE_SHOWN_EVENT,
  ArrowIconSize,
} = require('@component/carousel');

module.exports = {
  CarouselView,
  GridView,
  ProductPoolGrid,
  ProductPoolMedia,
  // constants from carousel
  ArrowIconSize,
  HORIZONTAL,
  VERTICAL,
  ITEM_SCROLL_TYPE,
  PAGE_SCROLL_TYPE,
  NEXT_EVENT,
  PREV_EVENT,
  READY_EVENT,
  LAST_PAGE_EVENT,
  PAGE_SHOWN_EVENT,
};
